/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, suffix: NonNullable<unknown>, name: NonNullable<unknown> }} Explorer_Nav_Move_Success_ToastInputs */

const en_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moved ${i?.count} item${i?.suffix} to "${i?.name}"`)
};

const fr_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deplace ${i?.count} element${i?.suffix} vers "${i?.name}"`)
};

const de_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} item${i?.suffix} nach "${i?.name}" verschoben`)
};

const it_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spostato ${i?.count} elemento${i?.suffix} in "${i?.name}"`)
};

const ru_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перемещен элемент ${i?.count}${i?.suffix} в "${i?.name}"`)
};

const es_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se movió el elemento ${i?.count} a "${i?.name}"`)
};

const zh_cn2_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将 ${i?.count} 项目 ${i?.suffix} 移动到“${i?.name}”`)
};

const ja_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} アイテム${i?.suffix} を "${i?.name}" に移動しました`)
};

const hi_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} आइटम${i?.suffix} को "${i?.name}" में स्थानांतरित किया गया`)
};

const pt_pt2_explorer_nav_move_success_toast = /** @type {(inputs: Explorer_Nav_Move_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O item ${i?.count} foi movido para "${i?.name}".`)
};

/**
* | output |
* | --- |
* | "Moved {count} item{suffix} to \"{name}\"" |
*
* @param {Explorer_Nav_Move_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_move_success_toast = /** @type {((inputs: Explorer_Nav_Move_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Move_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_move_success_toast(inputs)
	if (locale === "de") return de_explorer_nav_move_success_toast(inputs)
	if (locale === "it") return it_explorer_nav_move_success_toast(inputs)
	if (locale === "ru") return ru_explorer_nav_move_success_toast(inputs)
	if (locale === "es") return es_explorer_nav_move_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_move_success_toast(inputs)
	if (locale === "ja") return ja_explorer_nav_move_success_toast(inputs)
	if (locale === "hi") return hi_explorer_nav_move_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_move_success_toast(inputs)
	return en_explorer_nav_move_success_toast(inputs)
});